import firebase from '../firebase/firebaseConfig';

export const collections = () => ({
    users: () => firebase.firestore().collection('user'),

    subscriptions: () => firebase.firestore().collection('subscription'),

    promotionCodes: () => firebase.firestore().collection('promotionCode'),

    promotionCodesUsage: promotionCodeId =>
        firebase
            .firestore()
            .collection('promotionCode')
            .doc(promotionCodeId)
            .collection('usage'),
});
